import {
  AllStagesIntelligemsAppScopeList,
  BrowserStorefrontWriteScopeList,
  IntelligemsAppScopeList,
  IntelligemsAppScopeType,
  STOREFRONT_READ_SCOPE_PREFIX,
  STOREFRONT_SCOPE_PREFIX,
} from "@intelligems/ig-types";

const BROWSER_STOREFRONT_WRITE_SCOPES = new Set<string>(
  BrowserStorefrontWriteScopeList
);

export const getIntelligemsAppScopes = (
  stage: string
): readonly IntelligemsAppScopeType[] => {
  if (stage === "prod") {
    return IntelligemsAppScopeList;
  }
  return AllStagesIntelligemsAppScopeList;
};

/**
 * Whether a scope is served by a storefront access token rather than the admin
 * access token. Keyed on Shopify's naming convention so every storefront scope
 * we request now or later is covered without touching call sites.
 */
export const isStorefrontScope = (scope: string): boolean =>
  scope.startsWith(STOREFRONT_SCOPE_PREFIX);

/**
 * Whether a storefront scope belongs on the token that ships to the browser in
 * the plugin config: every read, plus the writes the plugin itself performs.
 *
 * A newly requested `unauthenticated_write_*` scope therefore never widens what
 * a shopper's browser can do — reaching the browser takes an explicit entry in
 * {@link BrowserStorefrontWriteScopeList}, where the reason for it is recorded.
 */
export const isBrowserStorefrontScope = (scope: string): boolean =>
  scope.startsWith(STOREFRONT_READ_SCOPE_PREFIX) ||
  BROWSER_STOREFRONT_WRITE_SCOPES.has(scope);
